<div id="contact-rank" class="popup" style="display: block">
  <div>
    <a id="close" class="close" (click)="close()" tabindex="-1"></a>
    <div class="popup-content">
        <span class="h1 block">Contact Rankipedia</span>
        <form [formGroup]="form" *ngIf="contactUsModel" name="frmContactUs">
          <div class="row">
            <div class="field half">
              <input type="text" id="reg-contact-name" placeholder="Name" formControlName="name" />
              <label for="reg-contact-name">Name</label>
              <div class="error-container" *ngIf="nameInvalid()">
                <small class="error">Name is required.</small>
              </div>
            </div>
            <div class="field half">
              <input type="text" id="reg-contact-email" placeholder="Email Address" formControlName="email" />
              <label for="reg-contact-email">Email Address</label>
              <div class="error-container" *ngIf="emailInvalid()">
                <small class="error">Please provide a valid email.</small>
              </div>
            </div>
          </div>
          <div class="field">
            <textarea formControlName="message"></textarea>
            <label for="register-zip">Message</label>
            <div class="error-container" *ngIf="messageInvalid()">
              <small class="error">Message is required.</small>
            </div>
          </div>
          <button class="btn primary" [disabled]="!formIsValid()" (click)="submitRequest()">Send Message</button>
        </form>
    </div>
  </div>
</div>
